module.exports = __webpack_public_path__ + "img/q2-12.cc1c0677.png";